"use strict";

// $(document).on('turbolinks:load', function(){
$(function(){

  const showMenu = () => {
    $("#burger-menu-background").show();
    $("#burger-menu-content").show();
    $("#hamburger-menu-btn").hide();
  }
  const hideMenu = () => {
    $("#burger-menu-background").hide();
    $("#burger-menu-content").hide();
    $("#hamburger-menu-btn").show();
  }

  $("#burger-menu-background").click(function() {
    // 背景をクリックして閉じる
    hideMenu();
  });

  $("#hamburger-menu-btn").click(
    function(){
      showMenu();
      return false;
    }
  );

  $("#burger-menu-content a").click(
    function() {
      hideMenu();
      return true;
      //window.location = $(this).attr('href');
      //return false;
    }
  );

  $(".menu_content_head_top .menu_close #menu_close_link").click(
    ()=>{hideMenu(); return false;}
  );

  $('input[type=file]').on('change', function(){
    const fileInput = $(this)[0];
    if (fileInput.files.length > 0) {
      $(this).parent().find("span.file-name").text(fileInput.files[0].name);
    }
  });

  $('a#totop_btn').click(() => {
    $('body,html').animate({
      scrollTop: 0
    }, 500);
    return false;
  });

  $('.search_container input[type="text"]').on('focus', function() {
    $('.navmenu_subsearch').show();
  }).on('blur', function() {
    setTimeout(function(){
      $('.navmenu_subsearch').hide();
    }, 200)
  });
});
